/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PhoneIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PhoneIcon({
  children,
  viewPath = "/DesignSystem/Svgs/PhoneIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="PhoneIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-19nRvK': alignSelf,'--mt-2-19nRvK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-19nRvK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-19nRvK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-19nRvK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-19nRvK': opacity,'--w-10-19nRvK': typeof width === 'number' ? `${width}px` : width,'--h-11-19nRvK': typeof height === 'number' ? `${height}px` : height,'--f-12-19nRvK': fill,'--a-7-19nRvK': isAnimated ? animation : "none",'--sd-8-19nRvK': isAnimated ? strokeDashoffset : 0,'--sd-9-19nRvK': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="PhoneIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M6.913 2.483A.782.782 0 006.19 2H2.783A.78.78 0 002 2.782V6.19a.783.783 0 001.336.553l1.15-1.15 2.61 2.61a.783.783 0 101.107-1.106l-2.61-2.611 1.15-1.15a.782.782 0 00.17-.853zM8.724 15.55a2.817 2.817 0 01-3.516-.375l-.396-.397a.949.949 0 010-1.335l1.669-1.66a.939.939 0 011.325 0 .95.95 0 001.336 0l2.66-2.66a.95.95 0 000-1.335.94.94 0 010-1.325l1.607-1.67a.95.95 0 011.335 0l.397.397a2.817 2.817 0 01.428 3.516 25.279 25.279 0 01-6.845 6.844z"
 style={{'--f-12-19nRvK': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}